// extracted by mini-css-extract-plugin
export default {"nav":"ResultListHeader-module__nav--cUyAm"};